import React from 'react';
import { Priority, PRIORITY_COLORS } from '../../types/order';

interface PriorityBadgeProps {
  priority: Priority;
  className?: string;
}

const PriorityBadge: React.FC<PriorityBadgeProps> = ({ priority, className = '' }) => {
  const colorMap: Record<string, string> = {
    gray: 'bg-gray-100 text-gray-800',
    amber: 'bg-amber-100 text-amber-800',
    red: 'bg-red-100 text-red-800',
  };
  
  const color = PRIORITY_COLORS[priority] || 'gray';
  const colorClasses = colorMap[color] || colorMap.gray;
  
  return (
    <span
      className={`inline-flex items-center px-2 py-1 rounded text-xs font-medium ${colorClasses} ${className}`}
    >
      {priority}
    </span>
  );
};

export default PriorityBadge;

